import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 1200);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35, ease: 'easeInOut' }}
      className="fixed inset-0 z-[100] bg-[#09090b] flex items-center justify-center p-4 select-none"
    >
      <div className="flex flex-col items-center justify-center gap-3">
        {/* Loading Logo */}
        <div className="w-5 h-5 border-2 border-white/20 border-t-white rounded-full animate-spin" />

        {/* Text */}
        <div className="font-mono text-xs sm:text-sm text-zinc-300 tracking-tight">
          loading shubh's portfolio...
        </div>
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
